import { homeSecurityPortalApi } from 'data/axios';
import { SUBSCRIPTION_CATEGORY, TPlanList } from 'typings';
import { ApiResponse } from './HttpRequest';
import { PIGGYBANK_ENDPOINTS } from './endpoints';

export async function getPiggybankPlanDetails(payload: {
  country: string;
  category: string;
  type: string;
}): Promise<ApiResponse<TPlanList[]>> {
  // Data is space-scoped and product-agnostic, so it uses a scope-based query
  // (scope=Space&sku_category=Data) rather than the product-scoped HOME_PLANS.
  const endpoint =
    payload.category === SUBSCRIPTION_CATEGORY.DATA
      ? PIGGYBANK_ENDPOINTS.DATA_PLANS(payload.country, payload.type)
      : PIGGYBANK_ENDPOINTS.HOME_PLANS(
          payload.country,
          payload.category,
          payload.type
        );

  const response = await homeSecurityPortalApi.get(endpoint);
  return response;
}
